import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BpRadio } from 'common/components/base-radio-group';
interface Props {
    name: string;
    options: boolean[];
    rowsTitle: string[];
    columnsTitle: string[];
    matrixAnswerType?: string;
}
const QuestionMatrixRadio: React.FC<Props> = ({
    name,
    rowsTitle = [],
    columnsTitle = [],
    matrixAnswerType = 'row',
}) => {
    const { control } = useFormContext();
    const displayMobileRowTitle =
        matrixAnswerType === 'row' ? rowsTitle : columnsTitle;
    const displayMobileColumnTitle =
        matrixAnswerType === 'row' ? columnsTitle : rowsTitle;
    return (
        <Box>
            <Table
                sx={{
                    backgroundColor: common.white,
                    display: ['none', 'table'],
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{
                                border: `2px solid ${colors.main}`,
                            }}
                        />
                        {columnsTitle.map((option, index) => (
                            <TableCell
                                key={`table-head-${index}`}
                                align="center"
                                sx={{
                                    border: `2px solid ${colors.main}`,
                                    fontSize: [
                                        '1rem',
                                        '1rem',
                                        '1rem',
                                        '2rem',
                                        '2rem',
                                    ],
                                    fontWeight: 500,
                                    lineHeight: '34px',
                                }}
                            >
                                {option}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rowsTitle.map((question, rowIndex) => (
                        <TableRow
                            key={`table-row-${rowIndex}`}
                            sx={{
                                border: `2px solid ${colors.main}`,
                            }}
                        >
                            <TableCell
                                sx={{
                                    border: `2px solid ${colors.main}`,
                                    backgroundColor: common.white,
                                    fontSize: [
                                        '1rem',
                                        '1rem',
                                        '1rem',
                                        '2rem',
                                        '2rem',
                                    ],
                                    fontWeight: 500,
                                }}
                            >
                                {question}
                            </TableCell>

                            {columnsTitle.map((column, colIndex) => (
                                <TableCell
                                    key={`table-cell-${rowIndex}-${colIndex}`}
                                    align="center"
                                    sx={{
                                        border: `2px solid ${colors.main}`,
                                    }}
                                >
                                    <FormControl>
                                        <Controller
                                            name={
                                                matrixAnswerType === 'row'
                                                    ? `${name}[${rowIndex}]`
                                                    : `${name}[${colIndex}]`
                                            }
                                            control={control}
                                            render={({ field }) => (
                                                <RadioGroup
                                                    {...field}
                                                    value={field.value || ''}
                                                    onChange={field.onChange}
                                                >
                                                    <FormControlLabel
                                                        value={`${question}&-&${column}`}
                                                        control={
                                                            <BpRadio
                                                                onClick={(
                                                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                                    e: any
                                                                ) => {
                                                                    if (
                                                                        e.target
                                                                            .value ===
                                                                        field.value
                                                                    ) {
                                                                        field.onChange(
                                                                            null
                                                                        );
                                                                    }
                                                                }}
                                                                size="medium"
                                                            />
                                                        }
                                                        label={undefined}
                                                    />
                                                </RadioGroup>
                                            )}
                                        />
                                    </FormControl>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Box
                sx={{
                    display: ['block', 'none'],
                }}
            >
                {displayMobileRowTitle.map((question, rowIndex) => (
                    <>
                        <Accordion
                            key={`accordion-${rowIndex}`}
                            disableGutters
                            square={true}
                            sx={{
                                backgroundColor: 'unset',
                                boxShadow: 'none',
                                border: 'none',
                                padding: 0,
                                fontSize: '1.2rem',
                                fontWeight: 700,
                                color: common.white,
                                borderBottom: `2px solid ${common.white}`,
                                '&::before': {
                                    display: 'none',
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ExpandMoreIcon
                                        sx={{
                                            fontSize: '3rem',
                                            color: common.white,
                                            transform: 'rotate(-90deg)',
                                            transition: 'transform 0.3s ease',
                                            '.Mui-expanded &': {
                                                transform: 'rotate(-180deg)',
                                            },
                                        }}
                                    />
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    padding: 0,
                                    marginBottom: '0.5rem',
                                    marginTop: '0.5rem',
                                }}
                            >
                                {question}
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    padding: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {displayMobileColumnTitle.map(
                                        (item, colIndex) => {
                                            return (
                                                <FormControl
                                                    key={`accordion-${rowIndex}-${colIndex}`}
                                                    sx={{
                                                        padding: '8px',
                                                        backgroundColor:
                                                            'white',
                                                        mb: '0.7rem',
                                                    }}
                                                >
                                                    <Controller
                                                        name={`${name}[${rowIndex}]`}
                                                        control={control}
                                                        render={({ field }) => (
                                                            <RadioGroup
                                                                {...field}
                                                                value={
                                                                    field.value ||
                                                                    ''
                                                                }
                                                                onChange={
                                                                    field.onChange
                                                                }
                                                            >
                                                                <FormControlLabel
                                                                    value={
                                                                        matrixAnswerType ===
                                                                        'row'
                                                                            ? `${question}&-&${item}`
                                                                            : `${item}&-&${question}`
                                                                    }
                                                                    sx={{
                                                                        '& .MuiFormControlLabel-label':
                                                                            {
                                                                                color: 'black',
                                                                                fontWeight: 500,
                                                                            },
                                                                        '& .MuiRadio-root.Mui-checked ~ .MuiFormControlLabel-label':
                                                                            {
                                                                                color: colors.main,
                                                                                fontWeight:
                                                                                    '500',
                                                                            },
                                                                    }}
                                                                    control={
                                                                        <BpRadio
                                                                            onClick={(
                                                                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                                                e: any
                                                                            ) => {
                                                                                if (
                                                                                    e
                                                                                        .target
                                                                                        .value ===
                                                                                    field.value
                                                                                ) {
                                                                                    field.onChange(
                                                                                        null
                                                                                    );
                                                                                }
                                                                            }}
                                                                            size="medium"
                                                                        />
                                                                    }
                                                                    label={item}
                                                                />
                                                            </RadioGroup>
                                                        )}
                                                    />
                                                </FormControl>
                                            );
                                        }
                                    )}
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </>
                ))}
            </Box>
        </Box>
    );
};

export default QuestionMatrixRadio;
